import { clear as clearIndexedDB } from "idb-keyval";
import { useLocalStorage } from "BEDROCK/utility/use-local-storage";
import { useAuthContext } from "BEDROCK/auth/auth-provider";

export const useSignOutHandler = () => {
  const { removeAll: clearLocalStorage } = useLocalStorage();
  const { signOut: authSignOut } = useAuthContext();

  const signOut = async () => {
    try {
      clearLocalStorage();
      await clearIndexedDB();
      await authSignOut();
    } catch (error) {
      console.error("Error clearing local store:", error);
    }
  };

  return { signOut };
};
